export const PAYMENT_REDIRECT_QUERY_PARAMNAME = "payment-success";
